/*
Contact form
*/

import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const ContactForm = ({ propertyId }) => {
  const [contactFormState, setContactFormState] = useState({
    email: "",
    name: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (name, value) => {
    setContactFormState({
      ...contactFormState,
      [name]: value,
    });
    setSubmitted(false);
  };

  const handleConfirmSend = async () => {
    setLoading(true);
    const response = await fetch(
      "https://www.gaia-travels.com/ajax/pages/feedback/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...contactFormState, property: propertyId }),
      }
    );

    const json = await response.json();
    if (json.ok) {
      setContactFormState({
        email: "",
        name: "",
        message: "",
      });

      setSubmitted("ok");
    } else {
      setSubmitted(json.errors);
    }

    setLoading(false);
  };

  let isFormEmpty =
    contactFormState.email === "" ||
    contactFormState.name === "" ||
    contactFormState.message === "";

  let confirmMessage = null;

  if (submitted === "ok") {
    confirmMessage = (
      <div
        className="text-center"
        style={{ display: "inline-block", paddingLeft: "10px", width: "100%" }}
      >
        <span className="text-muted">Kiitos, vastaamme pian!</span>
      </div>
    );
  } else if (submitted) {
    confirmMessage = (
      <div
        className="text-center"
        style={{ display: "inline-block", paddingLeft: "10px", width: "100%" }}
      >
        <span className="text-primary">{submitted}</span>
      </div>
    );
  }

  let buttonText = "Lähetä viesti";
  if (loading) {
    buttonText = (
      <FontAwesomeIcon
        icon={faSpinner}
        pulse
        className="text-white turn-icon"
        fixedWidth
        size="lg"
      />
    );
  }

  return (
    <form id="contact-form" method="post" className="form">
      <div className="controls">
        <div className="form-group">
          <label htmlFor="email" className="form-label">
            Lähettäjän Email *
          </label>
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Email"
            required="required"
            className="form-control"
            value={contactFormState.email}
            onChange={e => {
              handleInputChange(e.target.name, e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Nimi *
          </label>
          <input
            type="name"
            name="name"
            id="name"
            placeholder="Nimi"
            required="required"
            className="form-control"
            value={contactFormState.name}
            onChange={e => {
              handleInputChange(e.target.name, e.target.value);
            }}
          />
        </div>
        <div className="form-group">
          <label htmlFor="message" className="form-label">
            Millaista huvilaa etsit *
          </label>
          <textarea
            rows="4"
            name="message"
            id="message"
            placeholder="Ryhmän koko, toiveviikko(t) ja millaista huvilaa etsitte."
            required="required"
            className="form-control"
            value={contactFormState.message}
            onChange={e => {
              handleInputChange(e.target.name, e.target.value);
            }}
          ></textarea>
        </div>
        <div>
          <button
            type="submit"
            className={`btn ${
              isFormEmpty ? "btn-outline-primary" : "btn-primary"
            }`}
            style={{ width: "100%" }}
            disabled={isFormEmpty}
            onClick={e => {
              e.preventDefault();
              handleConfirmSend();
            }}
          >
            {buttonText}
          </button>
          {confirmMessage}
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
